import { gsap } from 'gsap'
import SelectImg from './_selectImg.es6'

export default class Pagination {
    constructor() {
        this.selectImg = new SelectImg()

        this.btnok = document.querySelector('.js-btn-paginate.-ok')
        this.cont = document.querySelector('.js-generator-cont')

        this.step = 1
        this.init()
    }

    init() {
        this.setPagination()
    }

    setPagination() {
        const btns = [...document.querySelectorAll('.js-btn-paginate')]
        const main = document.querySelector('.js-main')

        const setStep = () => {
            main.setAttribute('data-step', this.step)
        }

        const setSlect = () => {
            switch (this.step) {
                case 1:
                    MAIN.canvas.objbg.setChara()
                    break
                case 2:
                    this.selectImg.setSelectPh()
                    break
                case 3:
                    MAIN.canvas.objbg.setBgimg()
                    break
                case 4:
                    this.activeOkBtn()
                    MAIN.canvas.objdeco.resetbtn()
                    MAIN.canvas.objcopy.setCopyright()
                    break
                case 5:
                    MAIN.canvas.createImage()
                    break
            }
        }
        const resetSelect = () => {
            switch (this.step) {
                case 2:
                    MAIN.canvas.objdeco.removeSprite()
                    MAIN.canvas.objtext.removeSprite()
                    MAIN.canvas.objtext.resetSelect()
                    MAIN.canvas.objtext.offController()
                    MAIN.canvas.objtext.resetStyle()
                    break
                case 3:
                    MAIN.canvas.objcopy.removeSprite()
                    MAIN.canvas.objdeco.removeSprite()
                    break
            }
        }

        btns.forEach((btn) => {
            btn.addEventListener('click', () => {
                const dir = btn.getAttribute('data-dir')

                if (dir === 'ok') {
                    this.step++
                    this.resetOkBtn()
                    this.animaContNext()
                    setSlect()
                } else {
                    this.step--
                    this.activeOkBtn()
                    this.animaContPrev()
                    resetSelect()
                }

                setStep()
            })
        })
    }

    activeOkBtn() {
        this.btnok.classList.add('-active')
    }

    resetOkBtn() {
        this.btnok.classList.remove('-active')
    }

    animaContNext() {
        gsap.fromTo(this.cont, { opacity: 0, x: 20 }, { opacity: 1, x: 0, ease: 'circ.inOut', duration: 0.8, delay: 0 })
    }
    animaContPrev() {
        gsap.fromTo(this.cont, { opacity: 0, x: -20 }, { opacity: 1, x: 0, ease: 'circ.inOut', duration: 0.8, delay: 0 })
    }
}
